import { NewTab, PageTabAdv } from "../../../components";
import FundingDashboard from "./FundingDashboard";

import MainDashboard from "./MainDashboard";
import NoDataPage from "./NoDataPage";
import PaymentsDashboard from "../Employee/EmployeeProfile/Payments/Paymentsdashboard";
import InvoiceDashboard from "../Invoices/Invoices/InvoiceDashboard";
import ApDashboard from "../AccountsPayable/AccountsPayable/ApDashboard";
import Aging from "./Aging";

const Dashboard = () => {
  const SettingsMenus = [
    {
      title: "Main Dashboard",
      page: <MainDashboard />,
      type: "main",
    },
    {
      title: "AR Dashboard",
      page: <InvoiceDashboard />,
      type: "main",
    },
    {
      title: "AP Dashboard",
      page: <ApDashboard />,
      type: "main",
    },
    {
      title: "Funding Dashboard",
      page: <FundingDashboard />,
      type: "main",
    },
    {
      title: "Aging",
      page: <Aging />,
      type: "main",
    },
    // {
    //   title: "Payment Dashboard",
    //   page: <PaymentsDashboard />,
    //   type: "main",
    // },
    // {
    //   title: "No Data",
    //   page: <NoDataPage />,
    //   type: "main",
    // },
  ];
  return (
    <NewTab
      tabs={SettingsMenus}
      color="black"
      variant="outlined"
      mode="url"
      tabId="dashboard"
    />
  );
};

export default Dashboard;
